/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgUserGroup = {
  header: 'Todos os grupos de usuários ({{count}})',
  disabled: '(desativado)',
  uid: 'Código',
  name: 'Nome',
  unit: 'Unidade',
  orgUnit: 'Unidade',
  actions: '',

  sortBy: 'Classificar por',
  sort: {
    byName: 'Nome',
    byUnitName: 'Unidade',
    byGroupID: 'Grupo',
  },

  hint: 'Os grupos de usuários permitem combinar usuários em um único grupo, a fim de atribuir limites de compra para muitos usuários de uma só vez.',

  details: {
    title: 'Detalhes do grupo de usuários',
    subtitle: 'Grupo de usuários: {{ item.name }}',
  },

  edit: {
    title: 'Editar grupo de usuários',
    subtitle: 'Grupo de usuários: {{ item.name }}',
  },

  create: {
    title: 'Criar grupo de usuários',
    subtitle: '',
  },

  links: {
    user: 'Usuários',
    permission: 'Limites de compra',
  },

  messages: {
    update: 'Grupo de usuários {{ item.name }} atualizado com sucesso',
    create: 'Grupo de usuários {{ item.name }} criado com sucesso',
    deleteTitle: 'Excluir este grupo de usuários?',
    delete:
      'Os usuários desse grupo não são afetados quando o grupo de usuários é excluído.',
    deleted: 'Grupo de usuários {{ item.name }} excluído com sucesso',
  },

  breadcrumbs: {
    list: 'Todos os grupos de usuários',
    details: '{{name}}',
    users: 'Usuários',
    permissions: 'Limites de compra',
  },
};

export const orgUserGroupAssignedUsers = {
  title: 'Usuários asignados',
  subtitle: 'Grupo de usuários: {{ item.name }}',
  assigned: 'Usuário {{item.name}} Atribuído corretamente',
  unassigned: 'Usuário {{item.name}} não atribuído corretamente',
};

export const orgUserGroupUsers = {
  title: 'Gerenciar usuários',
  subtitle: 'Grupo de usuários: {{ item.name }}',
  assigned: 'Usuário {{item.name}} Atribuído corretamente',
  unassigned: 'Usuário {{item.name}} não atribuído corretamente',
  unassignAll: 'Cancelar a atribuição de tudo',
  unassignAllConfirmation: 'Todos os usuários não atribuídos corretamente',
};
export const orgUserGroupAssignedPermissions = {
  title: 'Limites de compra atribuídos',
  subtitle: 'Limite: {{ item.name }}',
  assigned: 'Limites de compra {{item.code}} atribuídos com sucesso',
  unassigned: 'Limites de compra {{item.code}} não atribuídos com sucesso',
};

export const orgUserGroupPermissions = {
  title: 'Gerenciar limites de compra',
  subtitle: 'Limite: {{ item.name }}',
  assigned: 'Limites de compra {{item.code}} atribuídos com sucesso',
  unassigned: 'Limites de compra {{item.code}} não atribuídos com sucesso',
};
